import { measurementCriteriaOptions } from '@/mocks/lessonPlan';

export interface EvaluationMetric {
  id: string;
  targetBehavior: string;
  measurementCriteria: string;
  successThreshold: string;
}

interface EvaluationRowProps {
  metric: EvaluationMetric;
  index: number;
  onChange: (metric: EvaluationMetric) => void;
  onRemove: () => void;
  metricNumberLabel: string;
  behaviorPlaceholder?: string;
  criteriaLabel?: string;
  thresholdPlaceholder?: string;
  removeLabel?: string;
}

export default function EvaluationRow({
  metric,
  index,
  onChange,
  onRemove,
  metricNumberLabel,
  behaviorPlaceholder,
  criteriaLabel,
  thresholdPlaceholder,
  removeLabel,
}: EvaluationRowProps) {
  const handleChange = (field: keyof EvaluationMetric, value: string) => {
    onChange({ ...metric, [field]: value });
  };

  return (
    <div className="bg-background-100/70 border border-background-200 rounded-xl p-4 relative group">
      <div className="flex items-center justify-between mb-3">
        <span className="font-heading font-700 text-sm text-foreground-800">
          {metricNumberLabel.replace('{{number}}', String(index + 1))}
        </span>
        <button
          type="button"
          onClick={onRemove}
          className="w-7 h-7 flex items-center justify-center rounded-lg text-foreground-400 hover:text-semantic-error hover:bg-semantic-error/10 transition-colors cursor-pointer opacity-0 group-hover:opacity-100"
          title={removeLabel}
        >
          <i className="ri-delete-bin-line text-sm" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div>
          <input
            type="text"
            value={metric.targetBehavior}
            onChange={(e) => handleChange('targetBehavior', e.target.value)}
            placeholder={behaviorPlaceholder}
            className="w-full xl-input text-sm"
          />
        </div>
        <div>
          <span className="text-xs font-label font-medium text-foreground-500 mb-1.5 block">{criteriaLabel}</span>
          <select
            value={metric.measurementCriteria}
            onChange={(e) => handleChange('measurementCriteria', e.target.value)}
            className="w-full xl-input text-sm cursor-pointer"
          >
            {measurementCriteriaOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <input
            type="text"
            value={metric.successThreshold}
            onChange={(e) => handleChange('successThreshold', e.target.value)}
            placeholder={thresholdPlaceholder}
            className="w-full xl-input text-sm"
          />
        </div>
      </div>
    </div>
  );
}